import { LastMessage } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from './createMakeCall';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => () =>
  makeCall<LastMessage>('GET', `${APIV2_URL}/conversations/last-message`);
